import { Outlet } from "react-router-dom";
import CabalTownLogo from "assets/icons/cabal-town-logo.png";

import { Box, useTheme } from "@mui/material";
import { Container } from "components/container";

import { Brick } from "components/Brick";
import { HeaderContainer, HeaderLogo } from "components/header/styled";
import { HeaderProfile } from "components/header/headerProfile";

export const Header = ({
  isShowHeader,
  navigateToPorfolio,
  navigateToExplorer,
  tgUserName,
  tgPhotoUrl,
}: {
  isShowHeader: boolean;
  navigateToPorfolio: () => void;
  navigateToExplorer: () => void;
  tgUserName: string;
  tgPhotoUrl: string;
}) => {
  const theme = useTheme();

  return (
    <>
      <Box sx={{ position: "relative" }}>
        <Box sx={{ background: theme.palette.surface.container }}>
          <Container>
            {isShowHeader ? (
              <HeaderContainer>
                <Brick variant="darker">
                  <Box
                    width="100%"
                    height="100%"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    padding={theme.spacing(0.3)}>
                    <HeaderLogo
                      src={CabalTownLogo}
                      alt="cabal-town-logo"
                      onClick={navigateToExplorer}
                    />
                  </Box>
                </Brick>
                {tgUserName ? (
                  <HeaderProfile
                    name={tgUserName}
                    onClick={navigateToPorfolio}
                    avatar={tgPhotoUrl}
                  />
                ) : null}
                {/* ) : (
                  <Box sx={{ width: "120px", alignSelf: "stretch" }}>
                    <RetroButton variant="white" onClick={handleLogin}>
                      <Typography variant="title-h3">Signup</Typography>
                    </RetroButton>
                  </Box>
                )} */}
              </HeaderContainer>
            ) : null}
          </Container>
        </Box>
      </Box>

      <Box sx={{ marginTop: theme.spacing(1) }}></Box>
      {/* spacer */}

      <Outlet />
    </>
  );
};
